import styled from 'styled-components'

export const HeaderWrapper = styled.div`
    background-color: white`
